export default __webpack_public_path__ + "static/media/logo-footer.f2bb4e6b.png";